export const AUTH_SIGN_IN = "AUTH_SIGN_IN";
export const AUTH_SIGN_IN_SUCCESS = "AUTH_SIGN_IN_SUCCESS";
export const AUTH_SIGN_IN_FAILURE = "AUTH_SIGN_IN_FAILURE";
export const AUTH_SET_LOADING = "AUTH_SET_LOADING";
